export const ModulesKeys = {
    paging: "getModulesPaging",
    delete: "deleteModule",
    get: 'moduleGetById',
    create: 'createModule',
    update: 'updateModule',
    getMenus: 'moduleMenuMapping',
    addMenus: 'addModuleMenu',
    deleteMenus: 'deleteModuleMenu',
    tree: 'moduleTreeView'
}